import { ThumbDownIcon, ThumbUpIcon } from "@/components/Icons";
import { t } from "@/i18n";
import { formatInt } from "@/lib/format";

// The positive and the negative ratings, each count before its thumb.
export function FeedbackCounts({ positive, negative }: { positive: number; negative: number }) {
  return (
    <>
      {formatInt(positive)}
      <ThumbUpIcon label={t("common.ratingPositive")} /> · {formatInt(negative)}
      <ThumbDownIcon label={t("common.ratingNegative")} />
    </>
  );
}
